module.exports = __webpack_public_path__ + "img/my-duels.573f5ddd.svg";